export const paperTypes = [
  {
    id: 1,
    customerName: "Essay (any type)",
  },
  {
    id: 2,
    customerName: "Presentation",
  },
  {
    id: 3,
    customerName: "Research Paper",
  },
  {
    id: 4,
    customerName: "Coursework",
  },
  {
    id: 5,
    customerName: "Assignment",
  },
  {
    id: 6,
    customerName: "Case Study",
  },
  {
    id: 7,
    customerName: "Term Paper",
  },
  {
    id: 8,
    customerName: "Book Report",
  },
  {
    id: 9,
    customerName: "Personal Statement",
  },
  {
    id: 10,
    customerName: "Article",
  },
  {
    id: 11,
    customerName: "Personal Reflection",
  },
  {
    id: 12,
    customerName: "Q&A",
  },
  {
    id: 13,
    customerName: "Annotated Bibliography",
  },
  {
    id: 14,
    customerName: "Movie Review",
  },
  {
    id: 15,
    customerName: "Critical Thinking",
  },
  {
    id: 16,
    customerName: "Admission Essay",
  },
  {
    id: 17,
    customerName: "Lab Report",
  },
  {
    id: 18,
    customerName: "Speech",
  },
  {
    id: 19,
    customerName: "Capstone Project",
  },
  {
    id: 20,
    customerName: "Math Problem",
  },
  {
    id: 21,
    customerName: "Statistics Report",
  },
  {
    id: 22,
    customerName: "Creative Writing",
  },
  {
    id: 23,
    customerName: "Dissertation",
  },
  {
    id: 24,
    customerName: "Peer Review",
  },
  {
    id: 25,
    customerName: "Scholarship Essay",
  },
  {
    id: 26,
    customerName: "Blog Writing",
  },
  {
    id: 27,
    customerName: "Business Plan",
  },
  {
    id: 28,
    customerName: "Thesis",
  },
];
